import {BaseModal, ModalFooter, ModalHeader} from "../BaseModal";
import React, {useEffect, useRef, useState} from "react";
import styled from 'styled-components';
import {Button} from "../../components/Button";
import {API} from "../../api";
import {PlatformToggle} from "../../components/PlatformToggle";
import {isMobileDevice} from "../../hooks/mobile/isMobile";
import {Checkbox} from "../../components/Checkbox";
import {useParams} from "react-router";

const SContent =  styled.div`
    display: flex;
    flex-direction: column;
    
    label {
        margin-bottom: 10px;
    }
    
    > div.pad {
        margin-top: 16px;
    }
    
    .search {
        display: flex;
    }
    
    input {
        
        width: 400px;
    }
    
    .user-card > div {
        display: flex;
        gap: 15px;
    }
    
    .user-card img {
        width: 56px;
        border-radius: 100%;
    }
`;

const api = new API();

export function RoomUserSettingsModal({isOpen, setOpen, selectedUser, isMobile=isMobileDevice()}) {
    const {room_hash} = useParams();

    const [loading, setLoading] = useState(false);
    const [admin, setAdmin] = useState(null);
    const [canRemote, setCanRemote] = useState(null);
    const [banned, setBanned] = useState(null);
    const [inited, setInited] = useState(false);

    useEffect(() => {
        if (selectedUser) {
            setAdmin(selectedUser.is_admin);
            setCanRemote(selectedUser.can_remote_control);
            setBanned(selectedUser.is_banned);
            setTimeout(() => {
                setInited(true)
            }, 200);
        }
    }, [selectedUser]);

    useEffect(() => {
        if (inited) {
            setLoading(true);
            api.updateRoomUser(room_hash, selectedUser.id, {
                is_admin: admin,
                can_remote_control: canRemote,
                is_banned: banned,
            }).finally(() => {
                setLoading(false);
            })
        }
    }, [admin, canRemote, banned]);


    return <BaseModal isOpen={isOpen} setOpen={setOpen}>
        <ModalHeader><span>Настройки пользователя</span></ModalHeader>
        <div>
            <SContent>
                <div className="user-card">
                    <div>
                        <div>
                            <img src={selectedUser?.avatar} />
                        </div>
                        <div>
                            <div>{selectedUser?.name}</div>
                        </div>
                    </div>
                </div>

                {selectedUser &&
                    <div className="user-permissions">
                        <Checkbox defaultChecked={admin} name="perm-admin" onChange={setAdmin} >Администратор</Checkbox>
                        <Checkbox defaultChecked={canRemote} name="perm-remote" onChange={setCanRemote} >Управление плеером хоста</Checkbox>
                        <Button size="s" responsive={isMobile} isRich={false} isPrimary={false} onClick={() => setBanned(!banned)}>{banned ? "Разбанить" : "Забанить"}</Button>
                    </div>
                }

            </SContent>
        </div>
        <ModalFooter>
            <Button size="s" responsive={isMobile} isRich={true} isPrimary={true} onClick={() => setOpen(false)} isLoading={loading}>Закрыть</Button>

        </ModalFooter>

    </BaseModal>
}
